<template>
    <div class="tco-tool__popout-grid-model" :class="{'tco-tool__popout-grid-model--selected': isSelected}" @click="selectThisModel()">
        <picture>
            <source v-if="model.image_webp" :srcset="model.image_webp" type="image/webp">
            <img :srcset="model.image" :alt="titleToUse" class="img-responsive tco-tool__popout-grid-model-img">
        </picture>
        <h4 class="tco-tool__popout-grid-model-title">{{ titleToUse }}</h4>
        <h5 class="tco-tool__popout-grid-model-price" v-if="price">from <span>{{ price }}</span></h5>
    </div>
</template>

<script>
import { customEvent } from '../../../../modules/tracking/AnalyticsEvents';
import NumberFormat from '../../../../used-vue/api/NumberFormat';
import { mapState } from 'vuex';

export default {
    props: {
        brand: {
            required: true,
            type: Object
        },
        model: {
            required: true,
            type: Object
        },
        isElectric: {
            required: false,
            default: false,
        }
    },
    data() {
        return {};
    },
    methods: {
        selectThisModel() {
            if (this.isElectric) {
                customEvent('TCO', 'Clicked', 'Step 2.1 - ' + this.brand.brand + ' ' + this.titleToUse);
            } else {
                customEvent('TCO', 'Clicked', 'Step 3.1 - ' + this.brand.brand + ' ' + this.titleToUse);
            }
            this.$emit('model-selected', this.model);
        }
    },
    computed: {
        ...mapState(['selectedEvModel', 'selectedIceModel']),
        isSelected() {
            if (this.isElectric) {
                if (this.selectedEvModel === null) {
                    return false;
                }
                return this.selectedEvModel.id == this.model.id;
            }
            if (this.selectedIceModel === null) {
                return false;
            }
            return this.selectedIceModel.id == this.model.id;
        },
        titleToUse() {
            if (this.isElectric) {
                if (!this.model.electric_model_title) {
                    return this.model.short_name;
                }

                return this.model.electric_model_title;
            }

            return this.model.short_name;
        },
        price() {
            const newVehiclesLength = this.model.new_vehicles.length;
            if (newVehiclesLength == 0) {
                return false;
            }
            let cheapestVehicle = false;
            for (let index = 0; index < newVehiclesLength; index++) {
                const newVehicle = this.model.new_vehicles[index];
                const fuel = newVehicle.fuel_type.toLowerCase();
                if (this.isElectric) {
                    if (!fuel.includes('electric')) {
                        continue;
                    }
                    if (cheapestVehicle === false || newVehicle.pricing_display_price < cheapestVehicle) {
                        cheapestVehicle = newVehicle.pricing_display_price;
                    }
                    continue;
                }

                if (fuel.includes('electric')) {
                    continue;
                }

                if (cheapestVehicle === false || newVehicle.pricing_display_price < cheapestVehicle) {
                    cheapestVehicle = newVehicle.pricing_display_price;
                }
            }
            if (cheapestVehicle === false) {
                return false;
            }

            return '£' + NumberFormat(cheapestVehicle);
        }
    },
}
</script>